import LandingNav from "../components/LandingNav";
import LandingDescriptionCard from "../components/LandingDescriptionCard";
import MarketIcon from "../assets/chart-line.svg";
import WalletIcon from "../assets/wallet.svg";
import HistoryIcon from "../assets/history.svg";
import CheckIcon from "../assets/check.svg";
import LogInIcon from "../assets/log-in.svg";
import DollarIcon from "../assets/dollar-sign.svg";
import TradeIcon from "../assets/trade.svg";
import ChartIcon from "../assets/chart-up.svg";
import HeroImg from "../assets/hero-img.png";
import HeroImgMobile from "../assets/hero-img-mobile.png";

export default function Landing() {
  const features = [
    {
      icon: MarketIcon,
      title: "Live Price Snapshots",
      description: "Track crypto prices and market movements to simulate dynamic trading conditions.",
    },
    {
      icon: WalletIcon,
      title: "Virtual Portfolio",
      description: "Manage your own portfolio with $10,000 virtual funds. Buy, sell, and rebalance like a real exchange.",
    },
    {
      icon: HistoryIcon,
      title: "Trade History",
      description: "Review trades and refine your strategy over time.",
    },
    {
      icon: CheckIcon,
      title: "Risk-Free Learning",
      description: "Learn without real money. Make mistakes, grow, and improve your trading skills safely.",
    },
  ];
  const steps = [
    {
      icon: LogInIcon,
      title: "1. Sign In With Google",
      description: "No complex setup — just one click to start trading.",
    },
    {
      icon: DollarIcon,
      title: "2. Get $10,000 Virtual Cash",
      description: "Start trading instantly with your demo funds.",
    },
    {
      icon: TradeIcon,
      title: "3. Explore & Trade",
      description: "Buy and sell top cryptocurrencies using frequently updated market snapshots.",
    },
    {
      icon: ChartIcon,
      title: "Track Your Progress",
      description: "Review portfolio performance and trading history to improve strategies.",
    },
  ];

  const handleLogin = () => {
    window.location.href = "https://vitru-trade-backend-production.up.railway.app/auth/google";
  }

  return (
    <div className="w-screen">
      <LandingNav />
      <section className="h-screen bg-stone-100 flex flex-col items-center">
        <div className="flex flex-col items-center relative -bottom-32 text-center space-y-8">
          <h1 className="text-5xl font-bold text-stone-900">VirtuTrade.</h1>
          <p className="text-lg text-stone-500 w-2/3 md:w-auto text-center">
            Practice crypto trading with real market data —
            <span className="font-semibold"> risk-free.</span>
          </p>
          <button onClick={handleLogin} className="px-6 py-3 bg-stone-900 lg:bg-stone-600 text-white rounded-full lg:hover:bg-stone-900 lg:transition font-semibold">Get Started</button>
          <img src={HeroImg} className="hidden lg:inline w-[700px] pt-12"/>
          <img src={HeroImgMobile} className="lg:hidden w-[300px] pt-12"/>
        </div>
      </section>

      <section className="bg-stone-100 py-12 pt-72">
        <h2 className="text-4xl font-bold text-center">Features</h2>
        <div className="grid md:grid-cols-4 gap-16 md:gap-10 px-6 md:px-[10%] mx-auto py-12">
          {features.map((feature, index) => (
            <LandingDescriptionCard key={index} icon={feature.icon} title={feature.title} description={feature.description}/>
          ))}
        </div>
        <h2 className="text-4xl font-bold text-center mt-36">How It Works</h2>
        <div className="grid md:grid-cols-4 gap-16 md:gap-10 px-6 md:px-[10%] mx-auto py-12">
          {steps.map((step, index) => (
            <LandingDescriptionCard key={index} icon={step.icon} title={step.title} description={step.description}/>
          ))}
        </div>
      </section>

      <section className="bg-stone-800 py-24 text-center text-white space-y-8 px-6">
        <h2 className="text-4xl font-bold">Start Trading Smarter Today</h2>
        <p className="">Join VirtuTrade and take your first step toward becoming a confident crypto trader — risk-free.</p>
        <button onClick={handleLogin} className="px-6 py-3 bg-stone-100 text-black rounded-full lg:hover:bg-stone-200 lg:transition font-semibold">🚀 Start Free Trading</button>
      </section>

      <footer className="bg-stone-100 py-4 text-center px-6">
        <p className="text-sm text-gray-500">
          ⚡ Market data is updated every <span className="font-semibold">5 minutes </span>
          and may not reflect live prices.
        </p>
      </footer>
    </div>
  );
}